import { GiantConfig } from "../types";

export const giantConfig: GiantConfig = {
    // Color themes can be defined in src/app/app.theme.scss
    colorTheme      : 'theme-default',
    customScrollbars: true,
    layout          : {
        style    : 'admin-layout',
        width    : 'fullwidth',
        navbar   : {
            primaryBackground  : 'giant-navy-50',
            secondaryBackground: 'giant-navy-900',
            folded             : false,
            hidden             : false,
            position           : 'left',
            variant            : 'navbar-vertical'
        },
        toolbar  : {
            customBackgroundColor: false,
            background           : 'giant-white-500',
            hidden               : false,
            position             : 'below-static'
        },
        footer   : {
            customBackgroundColor: true,
            background           : 'giant-navy-50',
            hidden               : false,
            position             : 'below-fixed'
        },
        sidepanel: {
            hidden  : false,
            position: 'right'
        }
    }
};
